export const booleanConverter = (val: boolean | string | null) => {
  return val !== false && val !== null && val !== 'false';
};

// Function takes colors in hex or rgb
export const getRGB = (str: string) => {
  const isHex = str.includes('#');
  let match;

  if (str.includes('#')) {
    match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(str);
  } else {
    match = /rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/i.exec(str);
  }
  let [red, green, blue] = [0, 0, 0];
  if (match) [red, green, blue] = match.slice(1, 4).map((n) => parseInt(n, isHex ? 16 : 10));
  return {
    red,
    green,
    blue,
  };
};

export const rgbToHsv = (r: number, g: number, b: number) => {
  const rabs = r / 255;
  const gabs = g / 255;
  const babs = b / 255;
  let rr = 0;
  let gg = 0;
  let bb = 0;
  let h = 0;
  let s = 0;
  const v = Math.max(rabs, gabs, babs);
  const diff = v - Math.min(rabs, gabs, babs);
  const diffc = (c: number) => (v - c) / 6 / diff + 1 / 2;

  if (diff === 0) {
    h = s = 0;
  } else {
    s = diff / v;
    rr = diffc(rabs);
    gg = diffc(gabs);
    bb = diffc(babs);

    if (rabs === v) {
      h = bb - gg;
    } else if (gabs === v) {
      h = 1 / 3 + rr - bb;
    } else if (babs === v) {
      h = 2 / 3 + gg - rr;
    }
    if (h < 0) {
      h += 1;
    } else if (h > 1) {
      h -= 1;
    }
  }
  return {
    h,
    s,
    v,
  };
};

export const hsvToRgbDevided = (h: number, s: number, v: number) => {
  const i = Math.floor(h * 6);
  const f = h * 6 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  let r = 0;
  let g = 0;
  let b = 0;

  switch (i % 6) {
    case 0:
      [r, g, b] = [v, t, p];
      break;
    case 1:
      [r, g, b] = [q, v, p];
      break;
    case 2:
      [r, g, b] = [p, v, t];
      break;
    case 3:
      [r, g, b] = [p, q, v];
      break;
    case 4:
      [r, g, b] = [t, p, v];
      break;
    case 5:
      [r, g, b] = [v, p, q];
      break;
  }
  const [red, green, blue] = [r, g, b].map((c) => Math.round(c * 255));

  return {
    red,
    green,
    blue,
  };
};

export const rgbToHex = (r: number, g: number, b: number) => {
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};

export const toHexColor = (color: string) => {
  if (!color.includes('rgb')) {
    return color;
  }
  const { red, green, blue } = getRGB(color);
  return rgbToHex(red, green, blue);
};
